
import { Vue, Component, Prop } from "vue-property-decorator";
import { openUiPanel } from "@/lib/panels/panels";
import { TreeNode } from "@/types/tree";
import { configStore, globalStore, uiStore } from "@/store/store";
import {
  addPresetToElement,
  copyPresetPropertiesToElement,
  removePresetFromElement
} from "@/lib/presets/presets";
import Icon from "@/components/UI/Icon.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import PresetDialog from "@/components/Settings/ElementPresets/PresetDialog.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import AlertBox from "@/components/Reusable/CustomInputs/AlertBox.vue";

@Component({
  components: { NiceButton, Icon, DropdownInput, AlertBox, PresetDialog }
})
export default class ElementPresetChooser extends Vue {
  @Prop()
  element!: TreeNode;

  get elementName() {
    return configStore.element(this.element.data.type).name;
  }

  get availablePresets() {
    return globalStore.presets;
  }

  get isPresetValid() {
    if (!this.currentPreset) return true;
    return (
      this.currentPreset &&
      this.presetItems.find(p => p.value === this.currentPreset)
    );
  }

  get isPresetsOverridesEnabled() {
    return configStore.isExperimentEnabled("design-presets-overrides");
  }

  get presetItems() {
    const type = this.element.data.type;

    return this.availablePresets
      .filter(preset => preset.availableForType === type)
      .map(preset => ({
        text: preset.name,
        value: preset.id
      }));
  }

  get currentPreset(): string | null {
    return this.element.data.properties?.meta?.preset;
  }

  get canCreatePreset() {
    return !!this.element.data.properties?.design;
  }

  selectPreset(preset: string) {
    addPresetToElement(
      preset,
      this.element.id,
      !this.isPresetsOverridesEnabled
    );
  }

  clear() {
    removePresetFromElement(this.element.id);
  }

  detach() {
    if (!this.currentPreset) return;
    copyPresetPropertiesToElement(this.currentPreset, this.element.id);
    removePresetFromElement(this.element.id);
  }

  edit() {
    uiStore.setActivePresetId(this.currentPreset);
    openUiPanel("presets");
  }

  // Preset Dialog
  savePresetDialog = false;
  openSavePresetDialog() {
    this.savePresetDialog = true;
  }

  closePresetDialog() {
    this.savePresetDialog = false;
  }
}
